import { Link } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'
import { useTranslations } from 'use-intl'

export interface ProductBreadcrumbItem {
  label: string
  to?: string
}

export function ProductBreadcrumbs({ items }: { items: ProductBreadcrumbItem[] }) {
  const t = useTranslations('ProductShell.breadcrumbs')

  return (
    <nav aria-label={t('ariaLabel')} className="flex min-w-0 items-center gap-1 overflow-x-auto text-sm text-muted">
      {items.map((item, index) => {
        const isLast = index === items.length - 1

        return (
          <span key={`${item.label}:${index}`} className="inline-flex min-w-0 items-center gap-1">
            {index > 0 && <ChevronRight className="size-4 shrink-0" aria-hidden="true" />}
            {item.to && !isLast
              ? (
                  <Link to={item.to as any} className="shrink-0 font-semibold text-muted transition hover:text-primary">
                    {item.label}
                  </Link>
                )
              : (
                  <span className="truncate font-semibold text-foreground" aria-current={isLast ? 'page' : undefined}>
                    {item.label}
                  </span>
                )}
          </span>
        )
      })}
    </nav>
  )
}
